import React, { useState, useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import { Link, useHistory } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { UpadateForgotPassword } from '../../apis/AgencyWithoutAuthHeaders';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { useSelector, useDispatch } from 'react-redux';
import { setUserDetailsObj } from '../../Redux/UserSlice';
import { ErrorToast, successToast } from '../../components/Toasts';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Typography,
  TextField,
  IconButton,
  Button,
  InputAdornment,
  Grid,
  Box,
  LinearProgress
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './Login.css';
import { base_url, base_logo_url } from '../../apis/constants';

const passwordRules = [
  { label: 'At least 8 characters', test: p => p.length >= 8 },
  { label: 'At least one uppercase letter (A–Z)', test: p => /[A-Z]/.test(p) },
  { label: 'At least one lowercase letter (a–z)', test: p => /[a-z]/.test(p) },
  { label: 'At least one number (0–9)', test: p => /[0-9]/.test(p) },
  { label: 'At least one special character (!@#$%*&*)', test: p => /[@$!%*#^()_+?&`~\-/]/.test(p) }
];

const getStrength = password => {
  const passed = passwordRules.filter(r => r.test(password)).length;
  if (!password) return { label: '', value: 0, color: '#e0e0e0' };
  if (passed <= 2) return { label: 'Weak', value: 33, color: '#f44336' };
  if (passed <= 4) return { label: 'Medium', value: 66, color: '#ff9800' };
  return { label: 'Strong', value: 100, color: '#4caf50' };
};

const UpdatePassword = props => {
  const queryData = props?.location?.search?.split('?')[1].split('&');
  const LoginEmail = queryData?.[0].split('=')[1];
  const forgotPassKey = queryData?.[1].split('=')[1];
  const history = useHistory();
  const dispatch = useDispatch();
  const selectorData = useSelector(setUserDetailsObj);

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const strength = getStrength(newPassword);
  const allRulesPassed = passwordRules.every(r => r.test(newPassword));
  const canSubmit = allRulesPassed && confirmPassword && newPassword === confirmPassword;

  const handleUpdatePass = e => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setConfirmPasswordError('Passwords do not match');
      return;
    }
    setConfirmPasswordError('');
    setIsLoading(true);
    UpadateForgotPassword({
      loginId: LoginEmail,
      passwordKey: forgotPassKey,
      password: newPassword,
      currentPassword: confirmPassword
    })
      .then(res => {
        if (res.status === 200) {
          setIsLoading(false);
          successToast('Password has been successfully updated! Please login now.');
          setTimeout(() => history.push('/agency-signin'), 1500);
        }
      })
      .catch(err => {
        setIsLoading(false);
        ErrorToast(err?.message);
      });
  };

  return (
    <React.Fragment>
      <ToastContainer
        position='top-center'
        style={{ width: 'auto' }}
        autoClose={4800}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* Background */}
      <div
        style={{
          position: 'fixed',
          inset: 0,
          backgroundImage: `url(${base_logo_url}carrier_logos/TMS-backg-img.png)`,
          backgroundSize: '100% 110%',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          zIndex: 0
        }}
      />

      <div style={{ position: 'relative', zIndex: 1 }}>
        <MetaTags>
          <title>Reset Password | TMS Shipping</title>
        </MetaTags>

        <section
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Grid
            container
            sx={{
              minHeight: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              px: { xs: 2, sm: 4 }
            }}
          >
            <Grid
              item
              xs={12}
              sm={7}
              md={5}
              lg={4}
              xl={3}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(255,255,255,0.97)',
                borderRadius: '16px',
                boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                padding: { xs: '24px 16px', sm: '32px 28px' }
              }}
            >
              <div style={{ width: '100%' }}>

                {/* Logo */}
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px', marginTop: '-12px' }}>
                  <svg
                    width='200'
                    height='52'
                    viewBox='0 0 1080 360'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                    style={{ display: 'block', margin: '0 auto' }}
                  >
                    <defs>
                      <linearGradient id='updateLogoGrad' x1='82' y1='72' x2='288' y2='278' gradientUnits='userSpaceOnUse'>
                        <stop offset='0' stopColor='#1297FF' />
                        <stop offset='1' stopColor='#006CFF' />
                      </linearGradient>
                    </defs>
                    <g
                      transform='translate(38 20) scale(.625)'
                      stroke='url(#updateLogoGrad)'
                      strokeWidth='54'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      fill='none'
                    >
                      <path d='M176 108 L256 188 L336 108' />
                      <path d='M108 176 L188 256 L108 336' />
                      <path d='M336 404 L256 324 L176 404' />
                      <path d='M404 336 L324 256 L404 176' />
                    </g>
                    <text x='365' y='220' fill='#000000' fontFamily='Inter, Arial, Helvetica, sans-serif' fontSize='118' letterSpacing='-4'>
                      <tspan fontWeight='700'>Ship</tspan>
                      <tspan fontWeight='400'>TechPro</tspan>
                    </text>
                  </svg>
                </div>

                {/* Lock icon with green check */}
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                  <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                    <Box sx={{
                      width: 54, height: 54, borderRadius: '50%',
                      bgcolor: '#e8eaf6', display: 'flex',
                      alignItems: 'center', justifyContent: 'center'
                    }}>
                      <LockOutlinedIcon sx={{ fontSize: 28, color: '#3361FF' }} />
                    </Box>
                    <CheckCircleIcon sx={{
                      position: 'absolute', bottom: -2, right: -2,
                      fontSize: 20, color: '#4caf50', bgcolor: 'white', borderRadius: '50%'
                    }} />
                  </Box>
                </Box>

                {/* Title */}
                <Typography variant='h6' sx={{ fontWeight: 700, textAlign: 'center', mb: 0.5, color: '#111' }}>
                  Reset Your Password
                </Typography>

                {/* Subtitle */}
                <Typography variant='body2' sx={{ textAlign: 'center', color: '#666', mb: 2, lineHeight: 1.5, fontSize: '0.8rem' }}>
                  Enter your new password below.<br />
                  Make sure it's strong and secure.
                </Typography>

                <Form style={{ width: '100%' }} onSubmit={handleUpdatePass}>

                  {/* New Password */}
                  <div style={{ marginBottom: '8px' }}>
                    <Typography variant='caption' style={{ fontWeight: 600, color: '#333' }}>
                      New Password
                    </Typography>
                    <TextField
                      fullWidth
                      id='newPassword'
                      type={showPassword ? 'text' : 'password'}
                      value={newPassword}
                      onChange={e => setNewPassword(e.target.value)}
                      placeholder='Enter new password'
                      variant='outlined'
                      size='small'
                      required
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position='start'>
                            <LockOutlinedIcon style={{ color: '#aaa', fontSize: 20 }} />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position='end'>
                            <IconButton size='small' onClick={() => setShowPassword(s => !s)}>
                              {showPassword ? <VisibilityOff style={{ fontSize: 20 }} /> : <Visibility style={{ fontSize: 20 }} />}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                      style={{ marginTop: '6px' }}
                    />
                  </div>

                  {/* Password strength */}
                  {newPassword && (
                    <Box sx={{ mb: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                        <Typography variant='caption' color='text.secondary'>Password strength:</Typography>
                        <Typography variant='caption' sx={{ fontWeight: 600, color: strength.color }}>
                          {strength.label}
                        </Typography>
                      </Box>
                      <LinearProgress
                        variant='determinate'
                        value={strength.value}
                        sx={{
                          height: 6, borderRadius: 3,
                          bgcolor: '#e0e0e0',
                          '& .MuiLinearProgress-bar': { bgcolor: strength.color, borderRadius: 3 }
                        }}
                      />
                    </Box>
                  )}

                  {/* Confirm Password */}
                  <div style={{ marginBottom: '8px' }}>
                    <Typography variant='caption' style={{ fontWeight: 600, color: '#333' }}>
                      Confirm New Password
                    </Typography>
                    <TextField
                      fullWidth
                      id='confirmPassword'
                      type={showPassword1 ? 'text' : 'password'}
                      value={confirmPassword}
                      onChange={e => {
                        setConfirmPassword(e.target.value);
                        setConfirmPasswordError('');
                      }}
                      placeholder='Re-enter new password'
                      variant='outlined'
                      size='small'
                      required
                      error={!!confirmPasswordError}
                      helperText={confirmPasswordError}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position='start'>
                            <LockOutlinedIcon style={{ color: '#aaa', fontSize: 20 }} />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position='end'>
                            <IconButton size='small' onClick={() => setShowPassword1(s => !s)}>
                              {showPassword1 ? <VisibilityOff style={{ fontSize: 20 }} /> : <Visibility style={{ fontSize: 20 }} />}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                      style={{ marginTop: '6px' }}
                    />
                  </div>

                  {/* Password requirements */}
                  {newPassword && <Box sx={{
                    bgcolor: '#f0f4ff', borderRadius: '8px',
                    p: '8px 12px', mb: 1.5,
                    border: '1px solid #dde3f5'
                  }}>
                    <Typography variant='caption' sx={{ fontWeight: 700, color: '#333', display: 'block', mb: 0.5 }}>
                      Password must contain:
                    </Typography>
                    {passwordRules.map((rule, i) => {
                      const passed = newPassword ? rule.test(newPassword) : false;
                      return (
                        <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 0.5 }}>
                          {passed
                            ? <CheckCircleIcon sx={{ fontSize: 15, color: '#4caf50' }} />
                            : <RadioButtonUncheckedIcon sx={{ fontSize: 15, color: '#bbb' }} />
                          }
                          <Typography variant='caption' sx={{ color: passed ? '#333' : '#888', fontSize: '0.72rem' }}>
                            {rule.label}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>}

                  {/* Reset Password button */}
                  <Button
                    fullWidth
                    disabled={!canSubmit}
                    type='submit'
                    variant='contained'
                    style={{
                      borderRadius: '8px',
                      padding: '8px',
                      fontSize: '15px',
                      fontWeight: 600,
                      textTransform: 'none',
                      marginBottom: '16px'
                    }}
                  >
                    {isLoading ? 'Updating...' : 'Reset Password'}
                  </Button>

                  {/* Back to Login */}
                  <Box sx={{ textAlign: 'center' }}>
                    <Link
                      to='/agency-signin'
                      style={{
                        color: '#3361FF', fontSize: '14px',
                        textDecoration: 'none',
                        display: 'inline-flex', alignItems: 'center',
                        gap: '4px', fontWeight: 500
                      }}
                    >
                      <ArrowBackIcon style={{ fontSize: 16 }} />
                      Back to Login
                    </Link>
                  </Box>

                </Form>
              </div>
            </Grid>
          </Grid>
        </section>
      </div>
    </React.Fragment>
  );
};

export default UpdatePassword;
